module.exports = __webpack_public_path__ + "static/media/hall-icon.8a6ace96.png";